export default {"src":"/_next/static/media/close_white.5a4ce8f2.svg","height":192,"width":192};